// src/pages/AuthPage.tsx
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";

const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 10vh;
  background: #f5f8ff;
`;

const Header = styled.header`
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  padding: 40px 20px;
  text-align: center;
  color: #fff;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;

const LogoCircle = styled.div`
  background: #fff;
  color: #2575fc;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 2rem;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  margin: 10px 0 0;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const Footer = styled.footer`
  text-align: center;
  padding: 20px;
  font-size: 0.8rem;
  color: #777;
  background: #f5f8ff;
`;

const AuthPage: React.FC = () => {
  // You can use the location object if needed.
  const location = useLocation();

  return (
    <AuthContainer>
      <Header>
        <LogoWrapper>
          <LogoCircle>Ltt</LogoCircle>
          <Title>Lavern Titan</Title>
        </LogoWrapper>
        <Subtitle>Welcome to Lavern Titan</Subtitle>
      </Header>
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
      <Footer>
        LavernAI CBC Platform for Students © {new Date().getFullYear()}
      </Footer>
    </AuthContainer>
  );
};

export default AuthPage;
